import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFieldNumber = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 34 19",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M.264 2.76l.816 2.832 3.168-.888V18H7.56V1.2H4.68L.264 2.76zM20.747 18v-3.192h-6.312l3.288-3.288c1.848-1.848 2.76-3.624 2.76-5.376 0-1.608-.552-2.904-1.632-3.84-1.08-.96-2.4-1.44-3.912-1.44-2.376 0-4.488 1.248-5.544 3.552l2.784 1.632c.6-1.32 1.536-1.968 2.808-1.968 1.272 0 2.184.864 2.184 2.184 0 .888-.648 2.016-1.92 3.36l-5.736 5.904V18h11.232zM32.566 3.936l-3.144 4.08c2.28.672 3.84 2.424 3.84 4.8 0 1.728-.576 3.072-1.752 4.056-1.152.984-2.568 1.464-4.248 1.464-2.616 0-4.824-1.224-5.76-3.552l2.832-1.632c.408 1.296 1.392 1.944 2.928 1.944 1.704 0 2.688-.864 2.688-2.28 0-1.368-.984-2.28-2.688-2.28h-.72l-1.272-1.92 3.312-4.32h-6.576V1.2h10.56v2.736z",
		fillRule: "nonzero"
	})
});
export default SvgFieldNumber;
